(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    if (window.goatChalkTrackingReady) {
      return;
    }

    window.goatChalkTrackingReady = true;

    const googleAdsId = 'AW-669351404';
    const googleAdsConversionLabels = {
      subscription_add_to_cart: 'iZVRCPCAndkcEOz7lb8C',
      one_time_add_to_cart: 'XUXrCPOAndkcEOz7lb8C',
      sample_request_success: '6r4HCPaAndkcEOz7lb8C',
      call_click: 'RfJXCPmAndkcEOz7lb8C'
    };
    const subscriptionPortalPath = '/a/subscriptions/manage';
    const subscriptionLoginPath = '/account/login?return_url=%2Fa%2Fsubscriptions%2Fmanage';

    const compactParams = (params) => Object.fromEntries(
      Object.entries(params || {}).filter((entry) => entry[1] !== undefined && entry[1] !== null && entry[1] !== '')
    );

    const getConversionValue = (params = {}) => {
      const value = Number(params.value);

      if (Number.isFinite(value) && value > 0) {
        return Number(value.toFixed(2));
      }

      return 1.0;
    };

    const trackGoogleAdsConversion = (eventName, params = {}) => {
      const conversionLabel = googleAdsConversionLabels[eventName];

      if (!conversionLabel || typeof window.gtag !== 'function') {
        return;
      }

      window.gtag('event', 'conversion', compactParams({
        send_to: `${googleAdsId}/${conversionLabel}`,
        value: getConversionValue(params),
        currency: params.currency || 'CAD',
        transaction_id: params.transaction_id || params.order_id,
        event_category: 'goat_chalk',
        transport_type: 'beacon'
      }));
    };

    const track = (eventName, params = {}) => {
      const basePayload = compactParams({
        event_category: 'goat_chalk',
        transport_type: 'beacon',
        page_location: window.location.href,
        page_title: document.title,
        ...params
      });

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        ...basePayload
      });

      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, basePayload);
        window.gtag('event', eventName, {
          ...basePayload,
          send_to: googleAdsId
        });
        trackGoogleAdsConversion(eventName, params);
      }
    };

    const trackOnce = (key, eventName, params = {}) => {
      try {
        if (window.sessionStorage.getItem(key) === 'true') {
          return;
        }

        window.sessionStorage.setItem(key, 'true');
      } catch (error) {
      }

      track(eventName, params);
    };

    const getPurchaseType = (form) => {
      if (form.classList.contains('goat-wholesale-home__form--subscription')) {
        return 'subscription';
      }

      if (form.classList.contains('goat-wholesale-home__form--onetime')) {
        return 'one_time';
      }

      return '';
    };

    const getPurchaseParams = (form) => {
      const selectedVariant = form.querySelector('input[name="id"]:checked');
      const quantityInput = form.querySelector('[data-goat-quantity-input]');
      const sellingPlanSelect = form.querySelector('[data-goat-selling-plan-select]');
      const quantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
      const priceInCents = Number.parseInt(selectedVariant?.dataset.goatUnitPrice || '0', 10) || 0;
      const currency = form.dataset.goatCurrency || 'CAD';
      const caseSize = selectedVariant?.dataset.goatVariantSize || '';

      return compactParams({
        currency,
        value: Number(((priceInCents * quantity) / 100).toFixed(2)),
        quantity,
        purchase_type: getPurchaseType(form),
        item_id: selectedVariant?.value,
        item_name: 'Wholesale liquid chalk case',
        item_variant: caseSize,
        case_size: caseSize,
        selling_plan_id: sellingPlanSelect?.value,
        selling_plan_name: sellingPlanSelect?.selectedOptions?.[0]?.textContent?.trim(),
        items: [
          compactParams({
            item_id: selectedVariant?.value,
            item_name: 'Wholesale liquid chalk case',
            item_variant: caseSize,
            quantity,
            price: Number((priceInCents / 100).toFixed(2))
          })
        ]
      });
    };

    const syncSubscriptionManageLinks = () => {
      const accountLoginLink = document.querySelector('.header__icon--account[href*="/account/login"], .menu-drawer__account[href*="/account/login"]');

      if (!accountLoginLink) {
        return;
      }

      document.querySelectorAll(`[data-goat-subscription-manage-link], a[href="${subscriptionPortalPath}"]`).forEach((link) => {
        link.setAttribute('href', subscriptionLoginPath);
      });
    };

    const trackSampleSuccess = () => {
      const successMessage = document.querySelector('.goat-home-sample__success');

      if (!successMessage) {
        return;
      }

      trackOnce(`goat-sample-success:${window.location.pathname}:${window.location.search}`, 'generate_lead', {
        lead_type: 'free_sample',
        form_location: 'home_sample'
      });
      trackOnce(`goat-sample-request-success:${window.location.pathname}:${window.location.search}`, 'sample_request_success', {
        lead_type: 'free_sample',
        form_location: 'home_sample'
      });
    };

    document.addEventListener('submit', (event) => {
      const form = event.target instanceof Element ? event.target : null;

      if (!form) {
        return;
      }

      if (form.matches('.goat-home-sample__form')) {
        track('sample_request_submit', {
          lead_type: 'free_sample',
          form_location: 'home_sample'
        });
        return;
      }

      if (!form.matches('.goat-wholesale-home__form')) {
        return;
      }

      const purchaseParams = getPurchaseParams(form);

      track('add_to_cart', purchaseParams);

      if (purchaseParams.purchase_type === 'subscription') {
        track('subscription_add_to_cart', purchaseParams);
      } else if (purchaseParams.purchase_type === 'one_time') {
        track('one_time_add_to_cart', purchaseParams);
      }
    }, { capture: true });

    document.addEventListener('click', (event) => {
      const link = event.target instanceof Element ? event.target.closest('a[href^="tel:"]') : null;

      if (!link) {
        return;
      }

      track('call_click', {
        link_url: link.getAttribute('href'),
        link_text: link.textContent.trim()
      });
    }, { capture: true });

    document.addEventListener('change', (event) => {
      const input = event.target instanceof Element ? event.target.closest('[data-goat-variant-size]') : null;

      if (!input || input.checked === false) {
        return;
      }

      const form = input.closest('.goat-wholesale-home__form');

      track('case_size_select', {
        purchase_type: form ? getPurchaseType(form) : '',
        case_size: input.dataset.goatVariantSize,
        item_id: input.value
      });
    }, { capture: true });

    syncSubscriptionManageLinks();
    trackSampleSuccess();
    document.addEventListener('shopify:section:load', () => {
      syncSubscriptionManageLinks();
      trackSampleSuccess();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goat-home-intro"] && !Shopify.designMode) return;
  try {
    
  if (!window.goatHomeIntroScrollReady) {
    window.goatHomeIntroScrollReady = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-goat-scroll-to-wholesale]');

      if (!trigger) {
        return;
      }

      const target = document.querySelector('.goat-wholesale-home');

      if (!target) {
        return;
      }

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goat-wholesale-home"] && !Shopify.designMode) return;
  try {
    
  const syncGoatWholesaleForms = (root = document) => {
    const formatMoney = (amountInCents, currency) => {
      const locale = document.documentElement.lang || navigator.language || 'en-CA';
      const value = amountInCents / 100;
      const hasCents = amountInCents % 100 !== 0;

      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency || 'CAD',
          currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: hasCents ? 2 : 0,
          maximumFractionDigits: hasCents ? 2 : 0
        }).format(value);
      } catch (error) {
        return `$${value.toFixed(hasCents ? 2 : 0)}`;
      }
    };

    const syncPurchaseMotion = (form, quantity) => {
      const motion = form.querySelector('[data-goat-purchase-motion]');

      if (!motion) {
        return;
      }

      const safeQuantity = Math.max(1, quantity || 1);
      const bottles = safeQuantity * 50;
      const caseCount = motion.querySelector('[data-goat-case-count]');
      const bottleCount = motion.querySelector('[data-goat-bottle-count]');
      const caseMeter = motion.querySelector('[data-goat-case-meter]');
      const caseTicks = motion.querySelectorAll('.goat-wholesale-home__case-tick');
      const caseWord = safeQuantity === 1 ? motion.dataset.goatCaseWordOne : motion.dataset.goatCaseWordOther;
      const bottleWord = motion.dataset.goatBottleWord || 'bottles';
      const motionState = `${safeQuantity}-${form.querySelector('[data-goat-selling-plan-select]')?.value || ''}`;

      if (caseCount) {
        caseCount.textContent = `${safeQuantity} ${caseWord || 'cases'}`;
      }

      if (bottleCount) {
        bottleCount.textContent = `${bottles} ${bottleWord}`;
      }

      caseTicks.forEach((tick, index) => {
        tick.classList.toggle('is-active', index < Math.min(safeQuantity, caseTicks.length));
      });

      if (caseMeter && caseMeter.dataset.goatMotionState !== motionState) {
        caseMeter.dataset.goatMotionState = motionState;
        caseMeter.classList.remove('is-updating');
        void caseMeter.offsetWidth;
        caseMeter.classList.add('is-updating');
      }

      const timeline = motion.querySelector('[data-goat-cadence-timeline]');
      const select = form.querySelector('[data-goat-selling-plan-select]');

      if (!timeline || !select) {
        return;
      }

      const selectedLabel = select.selectedOptions[0]?.textContent.trim() || '';
      const normalizedLabel = selectedLabel.toLowerCase();
      let cadenceMonths = 1;
      const mid = '50%';
      const end = '100%';

      if (normalizedLabel.includes('2')) {
        cadenceMonths = 2;
      } else if (normalizedLabel.includes('quarter') || normalizedLabel.includes('3')) {
        cadenceMonths = 3;
      } else if (normalizedLabel.includes('season') || normalizedLabel.includes('6')) {
        cadenceMonths = 6;
      }

      timeline.style.setProperty('--goat-cadence-mid', mid);
      timeline.style.setProperty('--goat-cadence-end', end);

      const formatOrderDate = (date) => {
        const locale = document.documentElement.lang || navigator.language || 'en-CA';

        try {
          return new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' }).format(date);
        } catch (error) {
          return `${date.getMonth() + 1}/${date.getDate()}`;
        }
      };

      const addCadenceMonths = (date, months) => {
        const result = new Date(date.getFullYear(), date.getMonth() + months, 1);
        const lastDay = new Date(result.getFullYear(), result.getMonth() + 1, 0).getDate();
        result.setDate(Math.min(date.getDate(), lastDay));
        return result;
      };

      const today = new Date();
      const labels = [
        motion.dataset.goatTodayLabel || 'Today',
        motion.dataset.goatNextLabel || 'Next',
        motion.dataset.goatFollowingLabel || 'Following'
      ];
      const orderDates = [
        today,
        addCadenceMonths(today, cadenceMonths),
        addCadenceMonths(today, cadenceMonths * 2)
      ];

      motion.querySelectorAll('[data-goat-cadence-date]').forEach((dateNode, index) => {
        const labelNode = dateNode.querySelector('[data-goat-cadence-date-label]');
        const valueNode = dateNode.querySelector('[data-goat-cadence-date-value]');

        if (labelNode) {
          labelNode.textContent = labels[index] || '';
        }

        if (valueNode && orderDates[index]) {
          valueNode.textContent = formatOrderDate(orderDates[index]);
        }
      });
    };

    const syncVariantMedia = (form, selectedVariant) => {
      if (!form || !selectedVariant) {
        return;
      }

      const purchase = form.closest('.goat-wholesale-home__purchase');
      const sectionRoot = form.closest('.shopify-section') || form.closest('.goat-wholesale-home') || document;
      const variantSize = selectedVariant.dataset.goatVariantSize;
      const productMedia = purchase ? purchase.closest('section')?.querySelector('[data-goat-product-media]') : null;

      if (productMedia && variantSize) {
        const frames = Array.from(productMedia.querySelectorAll('[data-goat-product-image]'));
        const targetFrame = frames.find((frame) => frame.dataset.goatProductImage === variantSize);

        if (targetFrame) {
          frames.forEach((frame) => {
            const isActive = frame === targetFrame;
            frame.classList.toggle('is-active', isActive);
            frame.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          });
        }
      }

      const mediaId = selectedVariant.dataset.goatMediaId;

      if (!mediaId) {
        return;
      }

      const galleries = Array.from(sectionRoot.querySelectorAll('media-gallery'));
      const gallery = galleries.find((item) => Array.from(item.querySelectorAll('[data-media-id]')).some((media) => media.dataset.mediaId === mediaId));

      if (gallery && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, true);
      }
    };

    const syncTotal = (form) => {
      const selectedVariant = form.querySelector('input[name="id"]:checked');
      const quantityInput = form.querySelector('[data-goat-quantity-input]');
      const total = form.querySelector('[data-goat-total-price]');
      const label = form.querySelector('[data-goat-total-label]');

      if (!selectedVariant || !quantityInput || !total) {
        return;
      }

      const casePrice = Number.parseInt(selectedVariant.dataset.goatUnitPrice || '0', 10);
      const quantity = Math.max(1, Number.parseInt(quantityInput.value || '1', 10) || 1);
      const amount = casePrice * quantity;
      const displayCurrency = form.dataset.goatCurrency || 'CAD';

      total.textContent = formatMoney(amount, displayCurrency);
      syncPurchaseMotion(form, quantity);
      syncVariantMedia(form, selectedVariant);

      if (label) {
        label.textContent = 'Estimated total';
      }
    };

    const requestSyncFrame = typeof window.requestAnimationFrame === 'function'
      ? window.requestAnimationFrame.bind(window)
      : (callback) => window.setTimeout(callback, 16);

    const scheduleStableSync = (callback) => {
      callback();
      requestSyncFrame(callback);
    };

    const syncRelatedPurchaseForms = (form) => {
      const purchase = form.closest('.goat-wholesale-home__purchase');

      if (!purchase || form.dataset.goatSyncing === 'true') {
        return;
      }

      const selectedVariant = form.querySelector('input[name="id"]:checked');
      const quantityInput = form.querySelector('[data-goat-quantity-input]');
      const selectedSellingPlan = form.querySelector('[data-goat-selling-plan-select]');

      purchase.querySelectorAll('.goat-wholesale-home__form').forEach((relatedForm) => {
        if (relatedForm === form) {
          return;
        }

        relatedForm.dataset.goatSyncing = 'true';

        if (selectedVariant) {
          const matchingVariant = Array.from(relatedForm.querySelectorAll('input[name="id"]')).find((input) => input.value === selectedVariant.value);

          if (matchingVariant) {
            matchingVariant.checked = true;
          }
        }

        if (quantityInput) {
          const relatedQuantity = relatedForm.querySelector('[data-goat-quantity-input]');

          if (relatedQuantity) {
            relatedQuantity.value = quantityInput.value;
          }
        }

        syncTotal(relatedForm);
        relatedForm.dataset.goatSyncing = 'false';
      });

      if (selectedSellingPlan) {
        purchase.querySelectorAll('[data-goat-muted-selling-plan-select]').forEach((select) => {
          select.value = selectedSellingPlan.value;
        });
      }
    };

    const getPurchaseState = (purchase) => {
      const activePanel = purchase.querySelector('[data-goat-purchase-panel]:not([hidden])') || purchase.querySelector('[data-goat-purchase-panel].is-active');
      const activeForm = activePanel ? activePanel.querySelector('.goat-wholesale-home__form') : purchase.querySelector('.goat-wholesale-home__form');

      return {
        mode: activePanel?.dataset.goatPurchasePanel || purchase.querySelector('[data-goat-purchase-toggle]:checked')?.value || 'subscription',
        variantId: activeForm?.querySelector('input[name="id"]:checked')?.value || '',
        quantity: activeForm?.querySelector('[data-goat-quantity-input]')?.value || '1',
        sellingPlan: activeForm?.querySelector('[data-goat-selling-plan-select]')?.value || ''
      };
    };

    const restorePurchaseState = (purchase, state) => {
      const matchingToggle = Array.from(purchase.querySelectorAll('[data-goat-purchase-toggle]')).find((input) => input.value === state.mode);

      if (matchingToggle) {
        matchingToggle.checked = true;
      }

      purchase.querySelectorAll('[data-goat-purchase-panel]').forEach((panel) => {
        const isActive = panel.dataset.goatPurchasePanel === state.mode;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
      });

      purchase.querySelectorAll('.goat-wholesale-home__form').forEach((form) => {
        const matchingVariant = Array.from(form.querySelectorAll('input[name="id"]')).find((input) => input.value === state.variantId);
        const quantityInput = form.querySelector('[data-goat-quantity-input]');
        const sellingPlanSelect = form.querySelector('[data-goat-selling-plan-select]');

        if (matchingVariant) {
          matchingVariant.checked = true;
        }

        if (quantityInput) {
          quantityInput.value = state.quantity || '1';
        }

        if (sellingPlanSelect && state.sellingPlan) {
          sellingPlanSelect.value = state.sellingPlan;
        }
      });
    };

    const syncCountryLocalizationControls = (nextDocument, countryCode) => {
      if (!nextDocument || !countryCode) {
        return;
      }

      document.querySelectorAll('form.localization-form').forEach((form) => {
        const countryInput = form.querySelector('input[name="country_code"]');
        const countrySelect = form.querySelector('select[name="country_code"]');

        if (!countryInput && !countrySelect) {
          return;
        }

        const nextForm = form.id ? nextDocument.getElementById(form.id) : null;
        const currentButtonLabel = form.querySelector('.disclosure__button span');
        const nextButtonLabel = nextForm ? nextForm.querySelector('.disclosure__button span') : null;

        if (countryInput) {
          countryInput.value = countryCode;
        }

        if (countrySelect) {
          countrySelect.value = countryCode;
        }

        if (currentButtonLabel && nextButtonLabel) {
          currentButtonLabel.textContent = nextButtonLabel.textContent;
        }

        form.querySelectorAll('.disclosure__link[data-value]').forEach((link) => {
          const isActive = link.dataset.value === countryCode;
          link.classList.toggle('disclosure__link--active', isActive);

          if (isActive) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      });
    };

    root.querySelectorAll('.goat-wholesale-home__currency-button[data-goat-country-code]').forEach((button) => {
      if (button.dataset.goatCurrencyReady === 'true') {
        return;
      }

      button.dataset.goatCurrencyReady = 'true';
      button.addEventListener('click', async () => {
        const purchase = button.closest('.goat-wholesale-home__purchase');
        const localizationFormId = purchase?.dataset.goatLocalizationForm;
        const localizationForm = localizationFormId ? document.getElementById(localizationFormId) : null;

        if (!purchase || !localizationForm || button.getAttribute('aria-pressed') === 'true') {
          return;
        }

        const state = getPurchaseState(purchase);
        const currencyButtons = purchase.querySelectorAll('.goat-wholesale-home__currency-button[data-goat-country-code]');
        let replaced = false;

        purchase.setAttribute('aria-busy', 'true');
        currencyButtons.forEach((currencyButton) => {
          currencyButton.disabled = true;
        });

        try {
          const formData = new FormData(localizationForm);
          formData.set('country_code', button.dataset.goatCountryCode);

          await fetch(localizationForm.action || '/localization', {
            method: localizationForm.method || 'POST',
            body: formData,
            credentials: 'same-origin',
            headers: {
              Accept: 'text/html'
            }
          });

          const response = await fetch(window.location.href, {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: {
              Accept: 'text/html'
            }
          });
          const html = await response.text();
          const nextDocument = new DOMParser().parseFromString(html, 'text/html');
          const nextPurchase = purchase.id ? nextDocument.getElementById(purchase.id) : null;

          syncCountryLocalizationControls(nextDocument, button.dataset.goatCountryCode);

          if (nextPurchase) {
            purchase.innerHTML = nextPurchase.innerHTML;
            restorePurchaseState(purchase, state);
            syncGoatWholesaleForms(purchase);
            purchase.removeAttribute('aria-busy');
            replaced = true;
          }
        } catch (error) {
          purchase.removeAttribute('aria-busy');
        }

        if (!replaced) {
          purchase.removeAttribute('aria-busy');
          currencyButtons.forEach((currencyButton) => {
            currencyButton.disabled = false;
          });
        }
      });
    });

    root.querySelectorAll('[data-goat-purchase-switch]').forEach((switcher) => {
      if (switcher.dataset.goatSwitchReady === 'true') {
        return;
      }

      const purchase = switcher.closest('.goat-wholesale-home__purchase');
      const toggles = switcher.querySelectorAll('[data-goat-purchase-toggle]');
      const panels = purchase ? purchase.querySelectorAll('[data-goat-purchase-panel]') : [];

      if (!purchase || toggles.length === 0 || panels.length === 0) {
        return;
      }

      switcher.dataset.goatSwitchReady = 'true';

      const syncPanels = () => {
        const selected = switcher.querySelector('[data-goat-purchase-toggle]:checked')?.value || 'subscription';

        panels.forEach((panel) => {
          const isActive = panel.dataset.goatPurchasePanel === selected;
          panel.hidden = !isActive;
          panel.classList.toggle('is-active', isActive);

          if (isActive) {
            const form = panel.querySelector('.goat-wholesale-home__form');

            if (form) {
              requestSyncFrame(() => {
                syncTotal(form);
                form.dispatchEvent(new Event('goat:purchase-panel-active', { bubbles: true }));
              });
            }
          }
        });
      };

      toggles.forEach((toggle) => {
        toggle.addEventListener('change', syncPanels);
      });

      syncPanels();
    });

    root.querySelectorAll('.goat-wholesale-home__form').forEach((form) => {
      if (form.dataset.goatTotalReady === 'true') {
        syncTotal(form);
        return;
      }

      form.dataset.goatTotalReady = 'true';
      form.addEventListener('input', () => {
        syncTotal(form);
        syncRelatedPurchaseForms(form);
      });
      form.addEventListener('change', () => {
        syncTotal(form);
        syncRelatedPurchaseForms(form);
      });
      scheduleStableSync(() => syncTotal(form));
    });

    root.querySelectorAll('[data-goat-quantity-control]').forEach((control) => {
      if (control.dataset.goatQuantityReady === 'true') {
        return;
      }

      const input = control.querySelector('[data-goat-quantity-input]');
      const decrease = control.querySelector('[data-goat-quantity-step="down"]');
      const increase = control.querySelector('[data-goat-quantity-step="up"]');

      if (!input || !decrease || !increase) {
        return;
      }

      control.dataset.goatQuantityReady = 'true';

      const getBounds = () => {
        const min = Number.parseInt(input.getAttribute('min') || '1', 10) || 1;
        const maxValue = Number.parseInt(input.getAttribute('max') || '', 10);

        return {
          min,
          max: Number.isNaN(maxValue) ? null : maxValue
        };
      };

      const getValue = () => {
        const bounds = getBounds();
        const parsed = Number.parseInt(input.value || String(bounds.min), 10);
        const current = Number.isNaN(parsed) ? bounds.min : parsed;
        const limitedMin = Math.max(bounds.min, current);

        return bounds.max === null ? limitedMin : Math.min(limitedMin, bounds.max);
      };

      const syncButtons = () => {
        const bounds = getBounds();
        const value = getValue();

        input.value = String(value);
        decrease.disabled = value <= bounds.min;
        increase.disabled = bounds.max !== null && value >= bounds.max;
      };

      const stepQuantity = (direction) => {
        const bounds = getBounds();
        const next = getValue() + direction;
        const limitedMin = Math.max(bounds.min, next);
        const value = bounds.max === null ? limitedMin : Math.min(limitedMin, bounds.max);

        input.value = String(value);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        syncButtons();
      };

      decrease.addEventListener('click', () => stepQuantity(-1));
      increase.addEventListener('click', () => stepQuantity(1));
      input.addEventListener('input', syncButtons);
      input.addEventListener('change', syncButtons);
      syncButtons();
    });

    root.querySelectorAll('.goat-wholesale-home__form--subscription').forEach((form) => {
      if (form.dataset.goatSubscriptionReady === 'true') {
        return;
      }

      form.dataset.goatSubscriptionReady = 'true';
      const select = form.querySelector('[data-goat-selling-plan-select]');

      const syncSubscription = () => {
        if (!select) {
          return;
        }

        let sellingPlanFields = form.querySelectorAll('input[name="selling_plan"]');

        if (sellingPlanFields.length === 0) {
          const field = document.createElement('input');
          field.type = 'hidden';
          field.name = 'selling_plan';
          form.appendChild(field);
          sellingPlanFields = form.querySelectorAll('input[name="selling_plan"]');
        }

        sellingPlanFields.forEach((field) => {
          field.disabled = false;
          field.value = select.value;
        });

        const sealSubscriptionOption = Array.from(form.querySelectorAll('input[type="radio"][name^="subs_type_"]')).find((input) => input.value !== 'one_time');

        if (sealSubscriptionOption) {
          sealSubscriptionOption.checked = true;
          sealSubscriptionOption.dispatchEvent(new Event('change', { bubbles: true }));
        }

        const sealInterval = form.querySelector('select[name="subs_interval"]');

        if (sealInterval && select.selectedOptions.length > 0) {
          const selectedLabel = select.selectedOptions[0].textContent.trim().toLowerCase();
          const targetLabel = selectedLabel === 'monthly' ? 'month' : selectedLabel;
          const matchingOption = Array.from(sealInterval.options).find((option) => option.textContent.trim().toLowerCase() === targetLabel);

          if (matchingOption) {
            sealInterval.value = matchingOption.value;
            sealInterval.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      };

      select?.addEventListener('change', syncSubscription);
      form.addEventListener('submit', syncSubscription, { capture: true });
      form.addEventListener('goat:purchase-panel-active', syncSubscription);
      scheduleStableSync(() => {
        syncSubscription();
        syncTotal(form);
      });
    });

    root.querySelectorAll('.goat-wholesale-home__form--onetime').forEach((form) => {
      if (form.dataset.goatOnetimeReady === 'true') {
        return;
      }

      form.dataset.goatOnetimeReady = 'true';

      const syncOnetime = () => {
        form.querySelectorAll('input[name="selling_plan"]').forEach((field) => {
          field.value = '';
          field.disabled = true;
        });

        const sealOnetimeOption = Array.from(form.querySelectorAll('input[type="radio"][name^="subs_type_"]')).find((input) => input.value === 'one_time');

        if (sealOnetimeOption) {
          sealOnetimeOption.checked = true;
          sealOnetimeOption.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };

      form.addEventListener('submit', syncOnetime, { capture: true });
      form.addEventListener('goat:purchase-panel-active', syncOnetime);
      scheduleStableSync(() => {
        syncOnetime();
        syncTotal(form);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncGoatWholesaleForms());
  } else {
    syncGoatWholesaleForms();
  }

  document.addEventListener('shopify:section:load', (event) => syncGoatWholesaleForms(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
